import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import "../styles/banner.css";

const buildStorageKey = (userId) =>
    userId ? `pm_email_verification_dismissed_${userId}` : "pm_email_verification_dismissed";

export default function EmailVerificationBanner() {
    const { user, resendVerificationEmail, role, roleLoading } = useAuth();
    const storageKey = buildStorageKey(user?.id);
    const [dismissed, setDismissed] = useState(() => {
        if (typeof window === "undefined") {
            return false;
        }
        return window.localStorage.getItem(storageKey) === "true";
    });
    const [status, setStatus] = useState(null);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        setDismissed(window.localStorage.getItem(storageKey) === "true");
    }, [storageKey]);

    if (!user || roleLoading || role !== "internal_staff") {
        return null;
    }

    if (user.email_confirmed_at) {
        return null;
    }

    if (dismissed) {
        return null;
    }

    const handleDismiss = () => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(storageKey, "true");
        }
        setDismissed(true);
    };

    const handleResend = async () => {
        setStatus(null);
        try {
            await resendVerificationEmail(user.email);
            setStatus("Verification email sent.");
        } catch (err) {
            setStatus(err?.message || "Unable to resend verification email.");
        }
    };

    return (
        <div className="email-verification-banner">
            <div className="banner-message">
                <strong>Email verification needed.</strong>
                <span>
                    Your email is not verified. Some features may be limited until you
                    confirm your address.
                </span>
            </div>
            <div className="banner-actions">
                <button className="btn" type="button" onClick={handleResend}>
                    Resend verification email
                </button>
                <button className="btn ghost" type="button" onClick={handleDismiss}>
                    Dismiss
                </button>
            </div>
            {status && <p className="banner-status">{status}</p>}
        </div>
    );
}
